import { render, staticRenderFns } from "./BannersHolidayShippingNotice.vue?vue&type=template&id=079e5a72"
import script from "./BannersHolidayShippingNotice.vue?vue&type=script&lang=js"
export * from "./BannersHolidayShippingNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports